import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import Spinner from '@atlaskit/spinner';

export const LoadingSpinner = () => {
	const intl = useIntl();
	return (
		<div
			css={css({
				display: 'flex',
				justifyContent: 'center',
				height: '600px',
				alignItems: 'center',
			})}
		>
			<div
				role="alert"
				aria-label={intl.formatMessage({
					id: 'pricing-calculator.loading',
					defaultMessage: 'Loading',
				})}
				data-testid="global-nav-user-profile-container-spinner"
			>
				<Spinner />
			</div>
		</div>
	);
};
